// Static option lists + date-range label computation for the MI dashboard.
// Per the spec (§21) the backend resolves actual dates from the range and
// comparison strings for the /v1/market-intelligence/* aggregator; the
// report rails (mi-stats.js) send explicit dates, so labels come from the
// shared range-window helper to stay in step with them.

import { rangeToWindow, previousWindow, windowLabel, isCustomRange } from '../../functions/range-window';
export const RANGE_OPTIONS = [{
  text: 'Today',
  value: 'today'
}, {
  text: 'Yesterday',
  value: 'yesterday'
}, {
  text: 'Last 7 Days',
  value: 'last_7_days'
}, {
  text: 'This Week',
  value: 'this_week'
}, {
  text: 'Last Week',
  value: 'last_week'
}, {
  text: 'This Month',
  value: 'this_month'
}, {
  text: 'Last Month',
  value: 'last_month'
}, {
  text: 'This Quarter',
  value: 'this_quarter'
}, {
  text: 'Last Quarter',
  value: 'last_quarter'
}, {
  text: 'This Year',
  value: 'this_year'
}, {
  text: 'Last Year',
  value: 'last_year'
}, {
  text: 'All Time',
  value: 'all_time'
}];
export const COMPARISON_OPTIONS = [{
  text: 'Previous Period',
  value: 'previous_period'
}, {
  text: 'Previous Year',
  value: 'previous_year'
}];

// Label for the header: "<current window> vs <comparison window>". Built
// from the SAME helper the data fetches use (functions/range-window.js) so
// the label can never disagree with the window actually queried. Handles
// custom_YYYYMMDD_YYYYMMDD tokens; empty for all_time / unknown.
export function computeRangeLabel(range, comparison, now = new Date()) {
  const current = rangeToWindow(range, now);
  if (!current) return '';
  const prev = previousWindow(range, comparison, now);
  return prev ? `${windowLabel(current)} vs ${windowLabel(prev)}` : windowLabel(current);
}

// Short badge text: preset label, or the custom window's dates.
export function rangeBadgeText(range) {
  if (isCustomRange(range)) return windowLabel(rangeToWindow(range));
  const hit = RANGE_OPTIONS.find(o => o.value === range);
  return hit ? hit.text : String(range || '');
}